module.exports = __webpack_public_path__ + "img/AIO5000-aodo.ca6b9ee0.png";